// removed by extract-text-webpack-plugin
module.exports = {"subSectionAnchor":"src-components-SubSection----index-module---subSectionAnchor---3XyhF","subSection":"src-components-SubSection----index-module---subSection---3SdFh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SubSection/index.module.scss
// module id = 74
// module chunks = 104101334113578 114276838955818